<template>
  <div>
    <div class="topic">产品推荐</div>
<!--    <div class="list-items">-->
<!--      <router-link class="list-item" v-for="(newProduct, newProductIndex) in newProducts" :key="newProductIndex" :to="'/product/'+newProduct.productId">-->
<!--        <img :src="'http://image.teamcorp.cn/wo_de/product/'+newProduct.image" alt="">-->
<!--        <div>{{newProduct.name}}</div>-->
<!--      </router-link>-->
<!--    </div>-->
      <swiper  :options="swiperOptions" class="mySwiper" ref="mySwiper" v-if="newProducts.length>1">
        <swiper-slide v-for="(newProduct, newProductIndex) in newProducts" :key="newProductIndex">
          <div class="img-box-item" @click="$router.push('/product/'+newProduct.productId)">
            <img class="meet-img-action" :src="'http://image.teamcorp.cn/wo_de/product/'+newProduct.image"/>
            <div>{{newProduct.name}}</div>
          </div>
        </swiper-slide>
<!--        <div class="swiper-pagination" slot="pagination"></div>-->
        <div class="swiper-button-prev swiper-button-whitehide hide" slot="button-prev"></div>
        <!-- 右箭头，下一个轮播图 -->
        <div class="swiper-button-next swiper-button-whitehide hide" slot="button-next"></div>
      </swiper>
<!--    </div>-->
    <div class="topic">最新新闻</div>
    <div class="news-container">
      <router-link class="news-main" :to="'/article/' + mainNews.articleId">
        <div class="news-main-info">
          <div class="news-main-info-title">{{ mainNews.title }}</div>
          <div class="news-main-info-date">{{ mainNews.addTime }}</div>
          <div class="news-main-info-brief">{{ mainNews.brief }}</div>
          <div class="news-main-info-detail">了解更多></div>
        </div>
        <img class="news-main-image" :src="mainNews.image" alt="">
      </router-link>
      <div class="news-list">
        <router-link class="news-list-item" v-for="(news, newsIndex) in newsList" :key="newsIndex" :to="'/article/' + news.articleId">
          <div class="news-list-item-date">{{ newsDate(news.addTime) }}</div>
          <div class="news-list-item-info">
            <div class="news-list-item-title">{{news.title}}</div>
            <div class="news-list-item-brief">{{news.brief}}</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="topic">经典项目</div>
    <div class="list-items">
      <router-link class="list-item" v-for="(project, projectIndex) in projects" :key="projectIndex" :to="'/article/' + project.articleId">
        <img :src="'http://image.teamcorp.cn/wo_de/article/'+ project.image" alt="">
        <div>{{project.title}}</div>
      </router-link>
    </div>
    <div class="topic">合作伙伴</div>
    <div class="partners">
      <div class="partner" v-for="(partner, partnerIndex) in partners" :key="partnerIndex">
        <img :src="partner.image" alt="">
        <div>{{partner.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/utils/service'
import dateFormatter from '@/utils/date'
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'
export default {
  components:{
    swiper,
    swiperSlide
  },
  data () {
    return {
      newProducts: [],
      mainNews: {},
      newsList: [],
      projects: [],
      partners: [
        {'name': '北京林业大学', 'image': '/static/partner.bjlydx.png'},
        {'name': '北京师范大学', 'image': '/static/partner.bjsfdx.png'},
        {'name': '西北农林科技大学', 'image': '/static/partner.xbnlkjdx.png'},
        {'name': '长安大学', 'image': '/static/partner.cadx.png'},
        {'name': '中国矿业大学', 'image': '/static/partner.zgkydx.png'},
        {'name': '中国农业大学', 'image': '/static/partner.zgnydx.png'},
        {'name': '中科院', 'image': '/static/partner.zgkxy.png'},
        {'name': '中国农科院', 'image': '/static/partner.zgnykxy.png'}
      ],
      swiperOptions: {
        slidesPerView: 4, // 一屏显示6张图片
        slidesPerGroup: 4,
        loop: true,
        paginationClickable: true,    //分页可点击
        pagination: {
          el:'.swiper-pagination',
          clickable:true
        },
        navigation:{
          nextEl:'.swiper-button-next',
          prevEl:'.swiper-button-prev'
        }
      },
    }
  },
  created () {
    this.loadNewProducts()
    this.loadNewsList()
    this.loadProjects()
  },
  methods: {
    loadNewProducts () {
      let _this = this
      service.get('/product/newProducts').then(function (response) {
        _this.newProducts = response
      })
    },
    loadNewsList () {
      let _this = this
      service.get('/article/mainNews').then(function (response) {
        _this.mainNews = response
      })
      service.get('/article/newsList').then(function (response) {
        _this.newsList = response
      })
    },
    loadProjects () {
      let _this = this
      service.get('/article/projects').then(function (response) {
        _this.projects = response
      })
    },
    newsDate (dateString) {
      return dateFormatter.toChinese(dateString, '%M月%D日%Y年')
    }
  }
}
</script>

<style scoped>
.mySwiper{
  display: flex;
  justify-content:flex-start;
  padding-left: 3.6%;
}
.list-items{
    display: flex;
    justify-content:flex-start;
}
.list-item {
    text-align: center;
    width:20%;
}
.list-item img {
  width: 220px;
  height: 165px;
}
.list-item div {
  font-size:14px;
  padding: 10px 0;
  text-align: center;
}
.news-main {
  display: flex;
  align-items: center;
  height:297px;
  margin-bottom: 22px;
}
.news-main-info {
  flex:1;
  background: #dee6ee;
  padding: 25px;
  height:240px;
  display: flex;
  flex-direction: column;
}
.news-main-info-title {
  font-size:19px;
  color:#333;
  line-height: 125%;
}
.news-main-info-date{
  font-size:14px;
  padding: 6px 0 0 8px;
  margin-bottom: 10px;
  color: #333333;
}
.news-main-info-brief{
  line-height: 22px;
  flex:1;
}
.news-main-info-detail{
  font-size:14px;
  color:#018FD7;
}
.news-main-image {
  width:395px;
  height:297px;
  overflow: hidden;
}
.news-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap:wrap;
}
.news-list-item {
  width:50%;
  margin-top:30px;
  display: flex;
}
.news-list-item-date {
  width:70px;
  height: 70px;
  background: #005aa8;
  color:#ffffff;
  font-size:14px;
  display: flex;
  text-align: center;
  align-items: center;
}
.news-list-item-info{
  padding: 4px 20px;
  flex:1;
}
.news-list-item-title{
  font-size: 16px;
  color:#333333;
  /* font-weight: 600; */
}
.news-list-item-brief{
  font-size:14px;
  color:#666666;
  line-height:22px;
  margin-top: 8px;
}
.news-container{
  margin: 0 0 45px 0;
}
.partners {
    display: flex;
    justify-content: flex-start;
}
.partner {
    text-align: center;
    width:12.5%;
}
.partner img {
  width: 90px;
  height: 90px;
}
.partner div {
  font-size:14px;
  color:#282828;
  padding: 9px 0;
  text-align: center;
}

.topic {
  font-size: 26px;
  line-height: 33px;
  letter-spacing: 0.5px;
  text-align: center;
  margin:45.5px 0 26px 0;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue